import { Space } from 'api/data/user/types';

const isSpaceNameTaken = (spaces: Space[], spaceName: string): boolean => {
  return spaces.some(space => space.name.trim().toLowerCase() === spaceName.trim().toLowerCase());
};

export default isSpaceNameTaken;
